"use client";

import React from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import {Theme} from "@mui/material/styles";
import {ColletteCarousel} from "@collette-travel/collette-common-controls";
import {Tour} from "@/types/dto/tours/tour";
import TourHighlightsCard from "@/components/destinations-page/tour-highlights-section/tour-highlights-card";

interface TourHighlightsCarouselProps {
  tours: Tour[]
}

const TourHighlightsCarousel = ({ tours }: TourHighlightsCarouselProps) => {
  const isLg = useMediaQuery((theme: Theme) => theme.breakpoints.up("lg"));

  if (tours.length === 0) {
    return null;
  }

  if (tours.length === 1) {
    return <TourHighlightsCard tour={tours[0]} index={0} />;
  }

  return (
    <ColletteCarousel
      testId="tour"
      variant="full-width"
      arrowPosition={isLg ? "sides" : "bottom"}
      showDots={isLg}
      dotsTheme="light"
    >
      {tours.map((tour, index) => (
        <TourHighlightsCard key={tour.id || index} tour={tour} index={index} />
      ))}
    </ColletteCarousel>
  );
};

export default TourHighlightsCarousel;